/*
===============================================================================================================
                                 Copyright 2021-2022, Blue Yonder Group, Inc.
                                              All Rights Reserved

                                THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
                                            BLUE YONDER GROUP, INC.

                            The copyright notice above does not evidence any actual
                                 or intended publication of such source code.

===============================================================================================================
*/

import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { LocaleContext } from '@/contexts/locale-context';

export default function TextDiv({
  selectorId,
  children,
  className,
}) {
  const { textDirection } = useContext(LocaleContext);

  return (
    <div id={selectorId} dir={textDirection} className={className}>
      {children}
    </div>
  );
}

TextDiv.defaultProps = {
  selectorId: null,
  className: '',
};

TextDiv.propTypes = {
  selectorId: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};
